import { Component, Host, h } from '@stencil/core'

import euOrganicLogo from './assets/eu-organic-loco.svg'
import reweLogo from './assets/rewe.svg'
import wineInModerationLogo from './assets/wine-in-moderation.svg'

/**
 * Represents the footer disclaimer component.
 */
@Component({
    tag: 'wf-footer-disclaimer',
    styleUrl: 'wf-footer-disclaimer.scss',
    scoped: true,
})
// eslint-disable-next-line require-jsdoc
export class WfFooterDisclaimer {

    /**
     * @inheritDoc
     */
    render() {
        return (
            <Host>
                <div class="wf-footer-container">
                    <div class="terms">
                        <a href="/agb">AGB</a>
                        <a href="/agb#widerrufsbelehrung?icid=footer_widerrufsrecht_nn_nn_nn_nn_nn_nn_nn">Widerrufsrecht</a>
                        <a href="/datenschutz">Datenschutz</a>
                        <a href="/nutzungsbedingungen">Nutzungsbedingungen</a>
                        <a href="/impressum">Impressum</a>
                        <a href="#uc-corner-modal-show" target="_parent">Privatsphäre-Einstellungen</a>

                        <div class="terms-disclaimer">
                            <p>Alle Preise in Euro (&euro;) inkl. gesetzlicher Mehrwertsteuer zuzüglich Versandkosten.</p>
                            <p>
                          Nach geltendem Recht sind wir verpflichtet, unsere Kunden auf die Existenz der europäischen
                          Online-Streitbeilegungs-Plattform hinzuweisen:
                                <a href="http://ec.europa.eu/odr" target="_blank">ec.europa.eu/odr</a>. Die REWE Wein online
                          GmbH nimmt nicht am Streitbeilegungsverfahren einer Verbraucherschlichtungsstelle teil und ist
                          dazu auch nicht verpflichtet.
                            </p>
                        </div>
                    </div>
                    <div class="additional-infos">
                        <div class="column">
                            <p>Zertifizierter Bio-Fachhändler durch DE-ÖKO-006</p>
                            <img loading="lazy" src={euOrganicLogo} alt="Zertifizierter Bio-Fachhändler"/>
                        </div>
                        <div class="column rewe">
                            <p>Ein Unternehmen der</p>
                            <img loading="lazy" src={reweLogo} alt="REWE Group"/>
                        </div>
                        <div class="column partner">
                            <p>Partner von</p>
                            <img loading="lazy" src={wineInModerationLogo} alt="Wine in Moderation"/>
                        </div>
                    </div>
                </div>
            </Host>
        )
    }

}
